var menuPosition = "closed";

function disableScrolling(){
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
}

function enableScrolling(){
    window.onscroll=function(){};
}

function openNav() {
    if (menuPosition == "closed") {
        document.getElementById("nav-main").style.left = "0";
        document.body.style.backgroundColor = "rgba(0,0,0,0.6)";
        jQuery("html,body").addClass("menu-open");
        jQuery(".menu-open").css("height","100%");
        jQuery(".menu-open").css("overflow","hidden");
        menuPosition="open";

        document.getElementById("mobile-hamburger").classList.remove("fa-bars");
        document.getElementById("mobile-hamburger").classList.add("line");
        document.getElementById("mobile-hamburger").classList.add("lines");
        document.getElementById("mobile-hamburger").setAttribute('aria-expanded', 'false');
        document.getElementById("mobile-hamburger").setAttribute('title', 'Open Main Navigation');

        jQuery('.svg-menu-icon.lazyImgs').each(function (index, value) {
            jQuery(this).attr('src',jQuery(this).attr('data-src'));
            //jQuery(this).removeClass('lazyImgs');
        });

        console.log('js nav open');

        disableScrolling();
    } else {
        jQuery("html,body").removeClass("menu-open");
        jQuery("html,body").css("height","auto");
        jQuery("html,body").css("overflow","auto");
        jQuery('nav#nav-main').css("height","100%");
        document.getElementById("nav-main").style.left = "-100%";
        document.body.style.backgroundColor = "#ededed";

        menuPosition="closed";

        document.getElementById("mobile-hamburger").classList.add("fa-bars");
        document.getElementById("mobile-hamburger").classList.remove("lines");
        document.getElementById("mobile-hamburger").classList.remove("lines");
        document.getElementById("mobile-hamburger").setAttribute("aria-expanded", "true");
        document.getElementById("mobile-hamburger").setAttribute("title" ,"Close Main Navigation");

        enableScrolling();
    }
}

function updateProfileDrawer(){
  if(NSCR.fn.readCookie(NSCR.config.cookie.loginStatus.name)){

    $(".profile-link-logout").show();
    $(".profile-link-login").hide();

    gigya.accounts.getAccountInfo({ callback: function(r){
      if(r.data && (r.data.accountStatus == "B" || r.data.accountStatus == "R")){
        return false;
      }
      if(r.profile.firstName){
        $('.profile-banner .profile-name').html("Hi, " + r.profile.firstName);
        $('.profile-banner .profile-name').addClass( 'profile-clickable' );
        $('.profile-banner .profile-name').click( function() {
          window.location.href = '/rewards';
        } );
      }else{
        jQuery('.profile-banner .profile-name').html("Hi, Race Fan ");
      }

      if(r.data.rewardsMember){

        //ToDo:make rewards API call here
        $.ajax( {
          url: 'https://nn6pl42zfl.execute-api.us-east-1.amazonaws.com/prod/nascar-rewards?action=getMemberHeaderData&memberId=' + r.UID,
          success: function( res ) {
            if( res.object !== null ) {
              $(".rewards-data").show();
              $(".banner-text").hide();

              $(".profile-dashboard").show();
              $(".profile-learn-more").hide();
              // set points
              $( "#rewards-data-points-value" ).html( res.object.pointBalance.toString().replace('.00', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") );
              // set tier
              switch ( res.object.tier ) {
                case 'ROOKIE':
                  $( '.rewards-data-icon' ).html( '<div class="rewards-steering"></div>' + res.object.tier.toUpperCase() )
                  break;
                case 'ALLSTAR':
                  $( '.rewards-data-icon' ).html( '<div class="rewards-star"></div>' + res.object.tier.toUpperCase() )
                  break;
                case 'ALLSTAR':
                  $( '.rewards-data-icon' ).html( '<div class="rewards-trophy"></div>' + res.object.tier.toUpperCase() )
                  break;
                default:
                  break;
              }
            }

          }
        } );
      }
    }});

  }
}
jQuery(document).ready(function($){
    $( 'a.mobile-hamburger-link' ).click( function( e ) {
        e.preventDefault();
    });
    var isClick = false;
    $( "#mobile-hamburger" ).mousedown(function(e) {
        isClick= true;
    }).focusin(function() {
        if (!isClick){
        $("#mobile-hamburger").click();
        }
    });
    // jQuery(document).on('rewardsGigyaEvent', function(event){
    if($( ".user-profile-button" ).length > 0){
    
      $( '.user-profile' ).click( function( e ) {
        jQuery(".lazy").Lazy();
          if($(this).hasClass("pin")){
            $(this).removeClass("pin");
            $('.user-profile-button svg').addClass('fa-circle-user');
          }else{
            $(this).addClass("pin");
            $('.user-profile-button svg').addClass('fa-circle-xmark');
          }
      });

      updateProfileDrawer();
      
    }
    // });
});
